import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentModule } from 'ngx-moment';

import { UriModule } from '®shared/url-utils';

import { SectionAlertsComponent } from './section-alerts.component';

@NgModule({
  imports: [CommonModule, MomentModule, UriModule],
  declarations: [SectionAlertsComponent],
  exports: [SectionAlertsComponent],
})
export class SectionAlertsModule {}
